"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.touristsPlaceholder = void 0;
var touristsPlaceholder = 'Количество туристов';
exports.touristsPlaceholder = touristsPlaceholder;